<app-breadcrumb [title]="'Combustible'" [items]="['Mantenimiento']" [active_item]="'Combustible'">
</app-breadcrumb>

<div class="container-fluid">
<div class="card">
  <div class="card-header d-flex align-items-center bg-primary text-white">
    <i class="icofont icofont-verification-check me-2"></i>
    <h5 class="mb-0"><strong>REGISTRO DE COMBUSTIBLE</strong></h5>
  </div>

  <div class="card-body">
    <form [formGroup]="formTanqueo">
      <div class="row g-3 mb-3">
        <div class="col-md-3">
          <label class="form-label" for="placa"><strong>Vehiculo</strong> *:</label>
          <ng-select #inputPlaca id="vehiculos" formControlName="placa" [items]="vehiculos" bindLabel="placa"
            bindValue="placa" placeholder="Selecciona una opción" class="js-example-placeholder-multiple">
          </ng-select>
        </div>
        <div class="col-md-3">
          <label class="form-label" for="fecha"><strong>Fecha de Tanqueo</strong> *:</label>
          <div class="input-group input-group-sm">
            <input #inputFecha id="fecha" formControlName="fecha" type="date" class="form-control form-control-lg fs-14"
              name="fecha" [max]="maxDate" onkeydown="return false;" />
          </div>
        </div>
        <div class="col-md-3">
          <label class="form-label" for="viaje"><strong>Estación de Servicio</strong> *:</label>
          <div class="input-group">
            <div class="form-control p-0 border-0">
              <ng-select #inputFecha placeholder="Selecciona una opción" formControlName="eds" [items]="empresaEds"
                bindLabel="nombre" bindValue="nombre" class="js-example-placeholder-multiple">
              </ng-select>
            </div>
            <button type="button" class="btn btn-primary btn-sm" (click)="openModalEmpresa(myModal2)"
              ngbTooltip="Crear empresa contratista">
              <i class="icofont icofont-plus"></i>
            </button>
          </div>
        </div>

        <div class="col-md-3">
          <label class="form-label"><strong>Kilometraje Actual</strong> *:</label>
          <input formControlName="km" type="number" class="form-control" placeholder="Ingrese el km al momento de tanquear" />
        </div>
        <div class="col-md-3">
          <label class="form-label" for="combustibles"><strong>Tipo de Combustible</strong> *:</label>
          <ng-select #inputPlaca id="combustibles" formControlName="combustible" [items]="combustibles"
            bindLabel="nombre" bindValue="nombre" placeholder="Selecciona una opción"
            class="js-example-placeholder-multiple">
          </ng-select>
        </div>
        <div class="col-md-3">
          <label class="form-label"><strong>Cantidad Tanqueada</strong> *:</label>
          <input formControlName="galones" type="number" class="form-control"
            placeholder="Ingrese la cantidad tanqueada" />
        </div>
        <div class="col-md-3">
          <label class="form-label"><strong>Precio</strong> *:</label>
          <input formControlName="valor" type="number" class="form-control"
            placeholder="Precio por unidad (Galón / litro)" />
        </div>
        <!-- Total calculado automáticamente con formato $ -->
        <input formControlName="total" type="hidden" />
        <!-- Campo solo para mostrar el total formateado -->
        <div class="col-md-3">
          <label class="form-label"><strong>Valor Total</strong> *:</label>
          <input [value]="totalFormateado" type="text" class="form-control" disabled />
        </div>
        <div class="col-md-3">
          <label class="form-label"><strong>Número de Factura</strong> *:</label>
          <input formControlName="factura" type="text" class="form-control"
            placeholder="Ingrese el número de factura" />
        </div>

        <div class="col-md-3">
          <label class="form-label" for="forma"><strong>Forma de Pago</strong> *:</label>
          <ng-select #inputPlaca id="forma" formControlName="forma" [items]="formapago" bindLabel="descripcion"
            bindValue="descripcion" placeholder="Selecciona una opción" class="js-example-placeholder-multiple">
          </ng-select>
        </div>

        
        </div>
        <div class="col-md-12">
          <label class="form-label"><strong>Observaciones</strong>:</label>
          
          <textarea formControlName="observaciones" type="text" class="form-control" ></textarea>
      </div>
      <div class="container-fluid py-4">
        <div class="row gy-6 my-4">
          <div *ngFor="let dropzone of dropzones" class="col-sm-12 col-md-12">
            <div class="card shadow-sm rounded h-100 d-flex flex-column mb-5">
              <!-- Encabezado -->

              <!-- Cuerpo -->
              <div class="card-body d-flex flex-column align-items-center justify-content-center">
                <!-- Input oculto -->
                <input type="file" [attr.multiple]="dropzone.id === 2 ? true : null" accept=".pdf,image/*"
                  class="d-none" (change)="onFileChange($event, dropzone.id)" [id]="'fileInput' + dropzone.id" />

                <!-- Dropzone visible -->
                <div
                  class="dropzone-label w-100 d-flex flex-column align-items-center justify-content-center py-4 border border-primary rounded cursor-pointer"
                  tabindex="0" (click)="abrirInput(dropzone.id)" (keydown.enter)="abrirInput(dropzone.id)"
                  (keydown.space)="abrirInput(dropzone.id)">
                  <div class="dropzone-preview w-100">
                    <ng-container *ngIf="dropzone.files.length > 0; else placeholder">
                      <!-- Vista condicional -->
                      <ng-container [ngSwitch]="dropzone.id">
                        <!-- ID 2: múltiples imágenes -->
                        <div *ngSwitchCase="2"
                          class="d-flex flex-row overflow-auto gap-3 w-100 px-2 mb-3 dropzone-preview-horizontal">
                          <div *ngFor="let file of dropzone.files; let i = index"
                            class="position-relative text-center flex-shrink-0" style="width: 150px;"
                            (mouseenter)="file.hover = true" (mouseleave)="file.hover = false">
                            <img *ngIf="file.type.startsWith('image/')" [src]="file.preview"
                              class="preview-img rounded shadow-sm mb-2" alt="Imagen"
                              (click)="$event.stopPropagation()" />
                            <button *ngIf="file.hover"
                              class="btn btn-danger btn-sm rounded-circle p-1 position-absolute top-0 end-0 m-1"
                              style="width: 24px; height: 24px; font-size: 12px; line-height: 1;"
                              (click)="removeFile(dropzone.id, i); $event.stopPropagation(); $event.preventDefault()">
                              ✖
                            </button>
                            <small class="text-muted text-truncate d-block" [title]="file.name">{{ file.name }}</small>
                          </div>
                        </div>

                        <!-- ID 1: PDF o imagen única -->
                        <div *ngSwitchDefault class="w-100 text-center">
                          <div *ngFor="let file of dropzone.files; let i = index" class="position-relative mb-3">
                            <button class="btn btn-danger btn-sm rounded-circle p-1 position-absolute top-0 end-0 m-1"
                              style="width: 24px; height: 24px; font-size: 12px; line-height: 1;"
                              (click)="removeFile(dropzone.id, i); $event.stopPropagation(); $event.preventDefault()">
                              ✖
                            </button>
                            <img *ngIf="file.type.startsWith('image/')" [src]="file.preview"
                              class="preview-img rounded shadow-sm" alt="Imagen" style="max-width: 250px;" />
                            <iframe *ngIf="file.type === 'application/pdf'" [src]="file.preview" width="100%"
                              height="600" style="border: 1px solid #ccc; border-radius: 5px;"></iframe>
                            <small class="text-muted text-truncate d-block mt-1" [title]="file.name">{{ file.name
                              }}</small>
                          </div>
                        </div>
                      </ng-container>
                    </ng-container>

                    <!-- Placeholder -->
                    <ng-template #placeholder>
                      <i class="bi bi-upload fs-1 text-dark mb-2"></i>
                      <p class="mb-0 fw-semibold text-dark text-center">
                        HAZ CLICK O ARRASTRA PARA CARGAR EL SOPORTE DE FACTURA {{ dropzone.name }}
                      </p>
                    </ng-template>
                  </div>
                </div>
              </div>

              <!-- Mensajes -->
              <div *ngIf="dropzone.error" class="alert alert-danger mx-3 my-2 text-center py-1" role="alert">
                {{ dropzone.error }}
              </div>
              <div *ngIf="dropzone.eliminado" class="alert alert-warning mx-3 my-2 text-center py-1" role="alert">
                Archivo eliminado correctamente
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>

 

    <div class="d-flex justify-content-center gap-3 mt-3">
      <button class="btn btn-primary d-flex align-items-center" type="button" (click)="guardarTanqueo()">
        GUARDAR
      </button>
    </div>

  </div>
</div>
</div>


<ng-template #myModal2 let-modal>
  <div class="card border-4 rounded-3">
    <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center rounded-top">
      <h5 class="mb-0"><strong>CREACIÓN DE ENTIDADES / EMPRESAS</strong></h5>
    </div>
    <div class="modal-body">
      <form [formGroup]="formEmpresa">
        <!-- Inputs antes de la tabla -->
        <div class="row g-3">
          <div class="col-md-3">
            <label class="form-label" for="nit"><strong>CC / NIT</strong> *:</label>
            <input class="form-control" id="nit" type="number" placeholder="Ingrese CC o NIT" formControlName="nit"
              required
              [class.is-invalid]="formEmpresa.get('nit')?.invalid && (formEmpresa.get('nit')?.touched || validate)"
              (input)="limitarLongitud($event, 10)" />
            <div *ngIf="formEmpresa.get('nit')?.invalid && (formEmpresa.get('nit')?.touched || validate)"
              class="invalid-feedback">
              Por favor, ingresa un número de documento.
            </div>

          </div>


          <div class="col-md-3">
            <label class="form-label" for="digito">
              <strong>Digito de Verificacción</strong> *:</label>
            <input #inputCodigo class="form-control" id="digito" type="number" required
              placeholder="Ingrese el dígito de verificación" formControlName="digito"
              [class.is-invalid]="formEmpresa.get('digito')?.invalid && (formEmpresa.get('digito')?.touched || validate)" />
            <div *ngIf="formEmpresa.get('digito')?.invalid && (formEmpresa.get('digito')?.touched || validate)"
              class="invalid-feedback">
              Por favor, ingresa un digito de verificación.
            </div>
          </div>

          <div class="col-md-3">
            <label class="form-label" for="nombre"><strong>Nombre Completo/Razon Social</strong> *:</label>
            <input #inputNombre class="form-control" id="nombre" type="text"
              placeholder="Ingrese el nombre o razon social" required formControlName="nombre"
              [class.is-invalid]="formEmpresa.get('nombre')?.invalid && (formEmpresa.get('nombre')?.touched || validate)" />
            <div *ngIf="formEmpresa.get('nombre')?.invalid && (formEmpresa.get('nombre')?.touched || validate)"
              class="invalid-feedback">
              Por favor, ingresa un nombre o razón social.
            </div>
          </div>

          <div class="col-md-3">
            <label class="form-label" for="direccion">
              <strong>Dirección</strong> *:</label>
            <input #inputDireccion class="form-control" id="direccion" type="text" required
              placeholder="Ingresa una dirección" formControlName="direccion"
              [class.is-invalid]="formEmpresa.get('direccion')?.invalid && (formEmpresa.get('direccion')?.touched || validate)" />
            <div *ngIf="formEmpresa.get('direccion')?.invalid && (formEmpresa.get('direccion')?.touched || validate)"
              class="invalid-feedback">
              Por favor, ingresa una dirección.
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label"><strong>Ciudad</strong> *:</label>
            <ng-select #inputCiudad id="ciudad" [items]="municipios" bindLabel="MUNICIPIO" bindValue="IDMUN"
              placeholder="Selecciona una opción" formControlName="ciudad">
            </ng-select>
            <div *ngIf="formEmpresa.get('ciudad')?.invalid && (formEmpresa.get('ciudad')?.touched || validate)"
              class="invalid-feedback">
              Por favor, ingresa una ciudad.
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label" for="telefono"><strong>Teléfono Fijo</strong>:</label>
            <input class="form-control" id="telefono" type="number" placeholder="Ingresa el teléfono fijo"
              formControlName="telefono" (input)="limitarLongitud($event, 10)"/>
            <div *ngIf="formEmpresa.get('telefono')?.invalid && formEmpresa.get('telefono')?.touched"
              class="invalid-feedback">
              El teléfono fijo debe tener 10 dígitos.
            </div>
          </div>

          <div class="col-md-3">
            <label class="form-label" for="celular"><strong>Teléfono Celular</strong> *:</label>
            <input #inputCelular class="form-control" id="celular" type="number" placeholder="Ingresa el teléfono celular"
              formControlName="celular" (input)="limitarLongitud($event, 10)"
              [class.is-invalid]="formEmpresa.get('celular')?.invalid && (formEmpresa.get('celular')?.touched || validate)" />
            <div *ngIf="formEmpresa.get('celular')?.invalid && (formEmpresa.get('celular')?.touched || validate)"
              class="invalid-feedback">
              Por favor, ingresa un número de celular.
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label" for="email">
              <strong>Correo Electrónico</strong> *:</label>
            <input #inputEmail class="form-control" id="email" type="text" required
              placeholder="Ingresa un correo valido" formControlName="email"
              [class.is-invalid]="formEmpresa.get('email')?.invalid && (formEmpresa.get('email')?.touched || validate)" />
            <div *ngIf="formEmpresa.get('email')?.invalid && (formEmpresa.get('email')?.touched || validate)"
              class="invalid-feedback">
              Por favor, ingresa un correo electronico.
            </div>
          </div>

          <div class="row g-3 mb-3">
            <div class="mb-3">
              <label><strong>Observaciones</strong>:</label>
              <textarea class="form-control" id="observaciones" rows="3" formControlName="observaciones"></textarea>
            </div>
          </div>

        </div>

      </form>
    </div>

    <div class="modal-footer">
      <button class="btn btn-primary" (click)="guardarEmpresa(modalEmpresaRef)">
        Guardar
      </button>
      <button class="btn btn-secondary" (click)="modal.dismiss()">
        Cancelar
      </button>
    </div>
  </div>
</ng-template>